import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';

import { FrontPageService } from '../../common/services/frontPage.service';
import { APIService } from '../../common/services/api.service';

import { FrontPage } from './frontPage.model';

export const frontPageResolver: ResolveFn<FrontPage> = async () => {
  const apiService = inject(APIService);
  const frontPageService = inject(FrontPageService);

  const result = Promise.all([frontPageService.getSections(), frontPageService.getMainPictures()]);

  apiService.processRequests();

  const [sections, mainPictures] = await result;
  return { sections, mainPictures };
};
